import Directory from '@/components/directory';

/**
 * The authenticated directory, and the only route that mounts the onboarding
 * tutorial. The public directory renders the same component and must not, or a
 * user passing through it during sign-up gets a second copy.
 */
export default function SecureDirectory() {
  return <Directory withOnboardingTutorial />;
}
